import { Store } from '@tanstack/react-store'
import type { ContactEnquiry, ConsultationRequest } from '@/types'

interface AppState {
  isMobileMenuOpen: boolean
  isSearchOpen: boolean
  currentService: string | null
  notifications: Notification[]
}

interface Notification {
  id: string
  type: 'success' | 'error' | 'info'
  message: string
}

interface AdminState {
  enquiries: ContactEnquiry[]
  consultations: ConsultationRequest[]
  selectedTab: string
  searchQuery: string
}

export const appStore = new Store<AppState>({
  isMobileMenuOpen: false,
  isSearchOpen: false,
  currentService: null,
  notifications: [],
})

export const adminStore = new Store<AdminState>({
  enquiries: [],
  consultations: [],
  selectedTab: 'dashboard',
  searchQuery: '',
})

export function toggleMobileMenu(): void {
  appStore.setState((state) => ({
    ...state,
    isMobileMenuOpen: !state.isMobileMenuOpen,
  }))
}

export function closeMobileMenu(): void {
  appStore.setState((state) => ({
    ...state,
    isMobileMenuOpen: false,
  }))
}

export function toggleSearch(): void {
  appStore.setState((state) => ({
    ...state,
    isSearchOpen: !state.isSearchOpen,
  }))
}

export function addNotification(
  type: Notification['type'],
  message: string
): void {
  const id = Date.now().toString()
  appStore.setState((state) => ({
    ...state,
    notifications: [...state.notifications, { id, type, message }],
  }))
  setTimeout(() => {
    removeNotification(id)
  }, 5000)
}

export function removeNotification(id: string): void {
  appStore.setState((state) => ({
    ...state,
    notifications: state.notifications.filter((n) => n.id !== id),
  }))
}